import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

export const Test = () => {
    return (
        <>
        <Header/>
        <h1>test</h1>
        <Footer />
        </>
    )
}